import { login, signUp } from '../auth/asyncThunks';
import { fetchUserInfo, getDeliveryUsers, verifyEmail } from './asyncThunks';

export const fetchUserInfoBuilder = builder => {
  builder.addCase(fetchUserInfo.pending, state => {
    state.fetchUserInfoPending = true;
  });
  builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
    state.fetchUserInfoPending = false;
    const { opsUser } = action.payload;

    state.user.id = opsUser.id;
    state.user.email = opsUser.email;
    state.user.fullName = opsUser.fullName;
    state.user.lang = opsUser.lang;
    state.user.verified = opsUser.verified;
  });
  builder.addCase(fetchUserInfo.rejected, state => {
    state.fetchUserInfoPending = false;
  });
};

export const loginBuilder = builder => {
  builder.addCase(login.fulfilled, (state, action) => {
    const { opsUser } = action.payload;

    state.user.id = opsUser.id;
    state.user.email = opsUser.email;
    state.user.fullName = opsUser.fullName;
    state.user.lang = opsUser.lang;
    state.user.verified = opsUser.verified;

    state.loginPending = false;
  });
};

export const signUpBuilder = builder => {
  builder.addCase(signUp.fulfilled, (state, action) => {
    const { opsUser } = action.payload;

    state.user.id = opsUser.id;
    state.user.email = opsUser.email;
    state.user.fullName = opsUser.fullName;
    state.user.lang = opsUser.lang;
    state.user.verified = opsUser.verified;
  });
};

export const verifyEmailBuilder = builder => {
  builder.addCase(verifyEmail.pending, state => {
    state.verifyEmailPending = true;
  });
  builder.addCase(verifyEmail.fulfilled, state => {
    state.user.verified = true;
    state.verifyEmailPending = false;
  });
  builder.addCase(verifyEmail.rejected, (state, action) => {
    state.verifyEmailPending = false;
    state.error = action.error.message;
  });
};

export const getDeliveryUsersBuilder = builder => {
  builder.addCase(getDeliveryUsers.pending, state => {
    state.getDeliveryUsersPending = true;
  });
  builder.addCase(getDeliveryUsers.fulfilled, (state, action) => {
    const { data, page, maxReached, total } = action.payload;

    if (page !== 1) {
      state.deliveryUsers.data = [...state.deliveryUsers.data, ...data];
    } else {
      state.deliveryUsers.data = data;
    }
    state.deliveryUsers.maxReached = maxReached;
    state.deliveryUsers.page = page;
    state.deliveryUsers.total = total;

    state.getDeliveryUsersPending = false;
  });
  builder.addCase(getDeliveryUsers.rejected, (state, action) => {
    state.getDeliveryUsersPending = false;
  });
};
